import { formatMoney } from "@brandclub/common-ui";
import { styled } from "@mui/material";

const TotalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  color: theme.vars.palette.text.primary,
}));

const TotalRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
  color: theme.vars.palette.text.primary,
}));

const TotalRowBold = styled(TotalRow)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "4px",
  paddingTop: "12px",
  color: theme.vars.palette.text.primary,
  borderTop: `1.2px solid ${theme.vars.palette.text.primary}`,
}));

interface CartTotalProps {
  subtotal: number;
  discount: number;
  shipping: number;
  estimatedTax: number;
  total: number;
  itemCount: number;
  deliveryEstimate: string;
  hasShippingAddress: boolean;
  hasShippingMethod: boolean;
}

export const CartTotal = ({
  subtotal,
  discount,
  shipping,
  estimatedTax,
  total,
  itemCount,
  deliveryEstimate,
  hasShippingAddress,
  hasShippingMethod,
}: CartTotalProps) => {
  // Determine shipping display text
  const getShippingDisplay = () => {
    if (!hasShippingAddress || !hasShippingMethod) {
      return "Enter shipping address";
    }
    return shipping === 0 ? "FREE" : formatMoney(shipping);
  };

  // Determine tax display text
  const getTaxDisplay = () => {
    if (!hasShippingAddress || !hasShippingMethod) {
      return "Enter shipping address";
    }
    return formatMoney(estimatedTax);
  };

  return (
    <TotalContainer>
      <TotalRow>
        <span>
          Subtotal ({itemCount} item{itemCount === 1 ? "" : "s"})
        </span>
        <span>{formatMoney(subtotal)}</span>
      </TotalRow>

      <TotalRow>
        <span>Shipping{deliveryEstimate ? ` (${deliveryEstimate})` : ""}</span>
        <span>{getShippingDisplay()}</span>
      </TotalRow>
      {discount > 0 && (
        <TotalRow>
          <span>Discount</span>
          <span>-{formatMoney(discount)}</span>
        </TotalRow>
      )}
      <TotalRow>
        <span>Estimated taxes</span>
        <span>{getTaxDisplay()}</span>
      </TotalRow>
      <TotalRowBold>
        <span>Total</span>
        <span>{formatMoney(total)}</span>
      </TotalRowBold>
    </TotalContainer>
  );
};
